import { render, staticRenderFns } from "./SPInfoCardInstructionList.vue?vue&type=template&id=01c58a84&scoped=true&"
import script from "./SPInfoCardInstructionList.vue?vue&type=script&lang=ts&"
export * from "./SPInfoCardInstructionList.vue?vue&type=script&lang=ts&"
import style0 from "./SPInfoCardInstructionList.vue?vue&type=style&index=0&id=01c58a84&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01c58a84",
  null
  
)

export default component.exports